// localStorage helpers for device persistence
const K = {
  device: "uhack_device_id",
  seen: "uhack_seen",
  saved: "uhack_saved",
  splash: "uhack_splash_done",
  session: "uhack_session_shuffle",
};

function uid() {
  return (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
}

export function getDeviceId() {
  let id = localStorage.getItem(K.device);
  if (!id) {
    id = uid();
    localStorage.setItem(K.device, id);
  }
  return id;
}

// per-session shuffle id: stable within a browser session (sessionStorage)
export function getSessionShuffle() {
  let id = sessionStorage.getItem(K.session);
  if (!id) {
    id = uid();
    sessionStorage.setItem(K.session, id);
  }
  return id;
}
export function reshuffle() {
  sessionStorage.setItem(K.session, uid());
}

export function getSeen() {
  try { return JSON.parse(localStorage.getItem(K.seen) || "[]"); } catch { return []; }
}
export function addSeen(id) {
  const s = new Set(getSeen());
  s.add(id);
  localStorage.setItem(K.seen, JSON.stringify([...s]));
}
export function clearSeen() {
  localStorage.setItem(K.seen, "[]");
}

export function getSaved() {
  try { return JSON.parse(localStorage.getItem(K.saved) || "[]"); } catch { return []; }
}
export function isSaved(slug) {
  return getSaved().some((x) => x.slug === slug);
}
export function toggleSaved(project) {
  const list = getSaved();
  const i = list.findIndex((x) => x.slug === project.slug);
  let next;
  if (i >= 0) {
    next = list.filter((x) => x.slug !== project.slug);
  } else {
    next = [{ slug: project.slug, project: project.project, team: project.team, track: project.track, one_liner: project.one_liner, u_tags: project.u_tags }, ...list];
  }
  localStorage.setItem(K.saved, JSON.stringify(next));
  return i < 0; // true if now saved
}

export function splashDone() {
  return localStorage.getItem(K.splash) === "1";
}
export function markSplashDone() {
  localStorage.setItem(K.splash, "1");
}
